import { NotifyHelper } from "../../../helpers/toast";
import { eHinhThucChiTietActionsObj } from "../../action-types/mien-giam/IHinhThucChiTietActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const hinhThucChiTietActions = {
  ...generateActions(
    eHinhThucChiTietActionsObj,
    "HINH_THUC_MIEN_GIAM_CHI_TIET"
  ),
  ...generateActionForKey(
    eHinhThucChiTietActionsObj,
    "HINH_THUC_MIEN_GIAM_CHI_TIET",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eHinhThucChiTietActionsObj,
    "HINH_THUC_MIEN_GIAM_CHI_TIET",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHinhThucChiTietActionsObj,
    "HINH_THUC_MIEN_GIAM_CHI_TIET",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eHinhThucChiTietActionsObj,
    "HINH_THUC_MIEN_GIAM_CHI_TIET",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
